// extracted by mini-css-extract-plugin
export var notificationHost = "_j1-0";